import { z } from 'zod';
import * as m from '@paraglide/messages';

export interface FieldData {
  default: string;
  type: string;
  blockedBy: string | null;
  advanced: boolean;
}

export type ToolchainData = {
  [section: string]: {
    [fieldName: string]: FieldData;
  };
};

export type ConfigFormData = {
  [section: string]: {
    [fieldName: string]: any;
  };
};

export const configSchema = z.object({
  meta: z.object({
    environment: z.string({ required_error: m.required_field() }).optional(),
    // .min(1, { message: 'Обязательное поле' }),
    toolchain: z.object({
      name: z.string({ required_error: m.required_field() }).optional(),
      // .min(1, { message: 'Обязательное поле' }),
    }),
  }),
});
